import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import CopyRow from '../../CopyRow';

// Fixed branding copy the client pastes into their IdP's app tile; it is
// deliberately not translated because it is pasted verbatim.
const appName = 'ExecOnline';
const appDescription =
  "In partnership with the world's top business schools, ExecOnline's leadership development solutions create a diverse pool of future-ready leaders.";

const BrandingCard: React.FC = () => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Brand the app tile" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card p-6">
      <p className="text-sm text-muted-foreground">
        <T kind="So ExecOnline is recognizable in your company's app launcher, use these when your IdP asks for the application's name and description:" />
      </p>
      <div className="mt-4 rounded-lg border border-border">
        <CopyRow label="App name" hint={<></>} value={appName} monospaced={false} />
        <CopyRow label="Description" hint={<></>} value={appDescription} monospaced={false} />
      </div>
    </div>
  </div>
);

export default observer(BrandingCard);
